import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { T } from "../i18n/LocaleType";
import { useRouterContext } from "../services/router/routerContext";
import style from './About.module.css';

/**
 * Statická stránka s informacemi o aplikaci
 */
export const About: React.FC = () => {

    const { t } = useTranslation();

    const {showEditor} = useRouterContext();

    return <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className={style.loading}
        style={{ position: 'absolute', inset: 0 }}
    >
        <div className={style.container}>
            {t(T.loading)}
            <button onClick={() => showEditor()}>Zpět na editor</button>
        </div>
        
    </motion.div>
}